import { render, staticRenderFns } from "./NezasaIdBox.vue?vue&type=template&id=2d40487c&scoped=true"
import script from "./NezasaIdBox.vue?vue&type=script&lang=js"
export * from "./NezasaIdBox.vue?vue&type=script&lang=js"
import style0 from "./NezasaIdBox.vue?vue&type=style&index=0&id=2d40487c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40487c",
  null
  
)

export default component.exports